import CryptoJS from 'crypto-js'

const SECRET_KEY = import.meta.env.VITE_CRYPTO_SECRET_KEY;
export function encryptData(data) {
  if (!SECRET_KEY) {
    console.log(data)
    return JSON.stringify(data);
  }
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    return null;
  }
}

export function decryptData(ciphertext) {
  if (!SECRET_KEY || !ciphertext) {
    try {
      return JSON.parse(ciphertext);
    } catch (error) {
      return null;
    }
  }
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
}
